import type { RouteLocationNormalizedLoaded } from 'vue-router';

import { computed } from 'vue';

/**
 * Extracts and parses route parameters as numbers
 */
export default function useRouteParams(route: RouteLocationNormalizedLoaded) {
  const parseParam = (param: string | string[] | undefined): number => {
    if (!param) return 0;
    return typeof param === 'string' ? Number.parseInt(param, 10) : Number(param);
  };

  const cessionId = computed(() => parseParam((route.params as Record<string, any>).cessionId));
  const financingId = computed(() => parseParam((route.params as Record<string, any>).financingId));

  return {
    cessionId,
    financingId,
  };
}
